// utils/loadablePage.js
import { Suspense } from "react";
import Page from "@jumbo/shared/Page";

export const LoadablePage = (Component) => (
  <Suspense fallback={<div>Loading...</div>}>
    <Page component={Component} layout="vertical-default" />
  </Suspense>
);
